var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163,
    height: 28,
    viewBox: "0 0 163 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-\\u767D\\u5E95",
    transform: "translate(-1280.365 736.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_5535",
    "data-name": "\\u7EC4 5535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_399",
    "data-name": "\\u7EC4 399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_256",
    "data-name": "\\u8DEF\\u5F84 256",
    d: "M1322.4-713.188l1.552-2.117.012-2.956h-7.681l-.007-2.025h7.679l.018-.987,4.588-1.725-.015-.528h-10.419v-2.024h15.629v2.589l-5.905,2.258-.016.417h7.3l.008,2.025h-7.367v3.564a1.6,1.6,0,0,1-.415,1.088,1.311,1.311,0,0,1-1.006.424Zm8.71-13.408.017-1.416h-10.687l-.015,1.416h-4.145v-3.445h1.476l-.476-2.052h4.107l.477,2.052h1.857l-.452-2.052h4.1l.454,2.052h1.759l.47-2.052h4.1l-.468,2.052h1.45v3.441Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_400",
    "data-name": "\\u7EC4 400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_257",
    "data-name": "\\u8DEF\\u5F84 257",
    d: "M1339.741-713.216l.024-18.065-.481-.78h3.239l-.025,18.845Zm12.755-.052.793-1.124-.026-1.28h-4.187l.01,2.4H1345.7l-.015-9.559h10.977l.006,8.047a2.081,2.081,0,0,1-.268,1.128.875.875,0,0,1-.814.384Zm-3.434-3.665h4.192l.02-1.6h-4.2Zm.01-2.838h4.194v-1.49h-4.19Zm-11.738,1.214.375-9.591h1.21l-.26,9.585Zm6-4.59-.11-5h1.238l.171,5Zm1.967-.812-.012-1.454h4.024l-.02-1.4h-3.247v-1.355h3.248l.021-1.4H1345.6l-.009-1.484h3.722l.018-.7-.247-.3h3.689l-.018,1h3.834l.01,1.484h-3.826l-.02,1.4h3.371v1.35h-3.377l.022,1.4h4.309l.009,1.456Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_404",
    "data-name": "\\u7EC4 404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_261",
    "data-name": "\\u8DEF\\u5F84 261",
    d: "M1371.059-713.189l1.592-2.143-.017-6.254h-5.492l-3.2,8.4h-4.077l3.2-8.4h-2.4l.009-2.051h16.085v8.936a1.506,1.506,0,0,1-.406,1.075,1.324,1.324,0,0,1-1.015.437Zm3.316-11.744-4.281-7.156h4.021l4.28,7.156Zm-15.329,0,4.078-6.837-.276-.319h4.5l-4.28,7.156Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_405",
    "data-name": "\\u7EC4 405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_262",
    "data-name": "\\u8DEF\\u5F84 262",
    d: "M1382.851-713.207l-.01-13.717h-2.326l-.007-2.024h2.351v-2.7l-.33-.41h3.6v3.1h2.326l.007,2.024h-2.346l.01,13.717Zm12.62-.028V-723.2H1393.3l-.318,9.961H1389.2l.611-17.366,9.967-1.464v2.15l-6.268.783-.148,3.914h6.843l-.011,2.022h-1.407v9.961Zm-14.865-.946L1381-725.77h1.041l-.392,11.589Zm6.765-1.537-.37-10.043h1.043l.371,10.043Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_406",
    "data-name": "\\u7EC4 406"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_263",
    "data-name": "\\u8DEF\\u5F84 263",
    d: "M1408.341-713.182l1.571-2.144.02-5.228h-6.449l-.006-2.15,3.674-2.684h-3.671l.009-2.389,2.309-1.643-3.241.134v-2.287l18.854-.526-.012,2.027-10.615.453-2.319,1.914h12.016v2.349h-9.4l-3.558,2.781h9.147l-.23-1.052h4.1l.79,3.59h-4.105l-.11-.513h-3.078v5.859a1.578,1.578,0,0,1-.415,1.088,1.314,1.314,0,0,1-1.006.424Zm9.765-.972-2.052-4.59h3.6l2.052,4.59Zm-15.869,0,2.066-4.59h3.577l-2.044,4.59Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_264",
    "data-name": "\\u8DEF\\u5F84 264",
    d: "M1424.056-715.356l6.407-.473.006,2.021-6.432.425Zm13.344,2.343v-7.969h3.2v5.424h2.186l.569-.641.007,3.18Zm-5.93-.176,1.286-7.793h3.189l-1.286,7.793Zm-7.414-4.23-.009-2.232,1.759-3.923h-1.749v-2.233l2.485-5.6-.31-.354h4.093l-2.764,6.164h2.762l-2.761,6.149h2.913l.006,2.025Zm16.5-4.612-.163-.5-8.973.483-.007-2.216,1.979-4.439h-2.446l.012-2.026h3.873l.015-.89-.571-.647h4.7l-.025,1.537h3.958l-.013,2.026h-5.44l-1.967,4.391,4.318-.228-.463-1.576h2.714l1.219,4.077Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_398",
    "data-name": "\\u7EC4 398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_256-2",
    "data-name": "\\u8DEF\\u5F84 256-2",
    d: "M1291.274-711.138h-9.917a1.284,1.284,0,0,0-.958,1.543,1.287,1.287,0,0,0,.958.957h28.049a1.285,1.285,0,0,0,.959-1.544,1.285,1.285,0,0,0-.959-.956Z",
    fill: "#22a888"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_397",
    "data-name": "\\u7EC4 397"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_169",
    "data-name": "\\u77E9\\u5F62 169",
    d: "M1304.4-728.638h0a3.5,3.5,0,0,1,3.506,3.5v8a3.5,3.5,0,0,1-3.506,3.5h0a3.5,3.5,0,0,1-3.506-3.5v-8A3.5,3.5,0,0,1,1304.4-728.638Z",
    fill: "#21c2f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_170",
    "data-name": "\\u77E9\\u5F62 170",
    d: "M1286.365-731.354h0a3.5,3.5,0,0,1,3.506,3.5v10.716a3.5,3.5,0,0,1-3.506,3.5h0a3.5,3.5,0,0,1-3.506-3.5v-10.716A3.5,3.5,0,0,1,1286.365-731.354Z",
    fill: "#fac92b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u77E9\\u5F62_171",
    "data-name": "\\u77E9\\u5F62 171",
    d: "M1295.38-736.638h0a3.5,3.5,0,0,1,3.506,3.5v16a3.5,3.5,0,0,1-3.506,3.5h0a3.5,3.5,0,0,1-3.506-3.5v-16A3.5,3.5,0,0,1,1295.38-736.638Z",
    fill: "#22a888"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.04be6ba375e109407b63cb13de2398cb.svg";
export { ForwardRef as ReactComponent };